<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-button
          variant="warning"
          size="sm"
          @click="addDetailModalHandler"
        >
          เลือกผลตรวจที่ต้องการลด
        </b-button>
        <span
          class="text-danger"
        >
          *
        </span>
        <sweet-modal ref="detailAddModal">
          <sweet-modal-tab
            id="test-tab"
            title="Test"
          >
            <b-form-input
              v-model="testFilter"
              @input="updateTestItems"
            />
            <b-table
              ref="testTable"
              style="height: 500px; overflow-y: auto; text-align: left;"
              sticky-header
              responsive
              show-empty
              select-mode="single"
              selectable
              thead-class="hidden_header"
              :fields="fields"
              :items="testSuggestList"
              empty-text="ไม่มีผลลัพธ์"
              @row-selected="onRowSelectedTest"
            />
          </sweet-modal-tab>
          <sweet-modal-tab
            id="set-test-tab"
            title="Set Test"
          >
            <b-form-input
              v-model="setTestFilter"
              @input="updateSetTestItems"
            />
            <b-table
              ref="setTestTable"
              style="height: 500px; overflow-y: auto; text-align: left;"
              sticky-header
              responsive
              show-empty
              thead-class="hidden_header"
              select-mode="single"
              selectable
              :fields="fields"
              :items="setTestSuggestList"
              @row-selected="onRowSelectedSetTest"
            />
          </sweet-modal-tab>
        </sweet-modal>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import LabInvoiceDetailAddSuggestList from "../../Account/LabInvoiceDetailAddSuggestList";
  import { mapActions } from 'vuex'

  export default {
    name: "TestSelectedModal",
    props: {
      chooseItemHandler: {
        type: Function,
        default: () => false
      }
    },
    data() {
      return {
        tests: [],
        testSuggestList: [],
        setTestSuggestList: [],
        setTests: [],
        testFilter: null,
        setTestFilter: null,
        fields: [
          { key: 'name', label: 'ชื่อ', thStyle: { display: 'none'}}
        ],
        suggestListComponent: LabInvoiceDetailAddSuggestList,
      }
    },
    methods: {
      ...mapActions({
        'getTests': 'Test/getTestsBySpecie',
        'getSetTests': 'Test/getSetTestsBySpecie'
      }),
      async addDetailModalHandler() {
        this.tests = await this.getTests()
        this.testSuggestList = JSON.parse(JSON.stringify(this.tests)) // clone test
        this.setTests = await this.getSetTests()
        this.setTestSuggestList = JSON.parse(JSON.stringify(this.setTests)) // clone set test
        this.$refs['detailAddModal'].open()
      },
      async onRowSelectedTest(item) {
        if (item.length <= 0) {
          return
        }
        this.$refs['detailAddModal'].close();
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการเลือก',
          text: `คุณต้องการเลือก ${item[0].name} ลดราคาใช่หรือไม่?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'เลือก',
          cancelButtonText: 'ยกเลิก',
          showLoaderOnConfirm: true,
        })

        if (confirm.value) {
          this.chooseItemHandler(item[0].id, item[0].name, 'test')
        } else {
          this.$refs['testTable'].clearSelected()
          this.$refs['setTestTable'].clearSelected()
          this.$refs['detailAddModal'].open()
        }
      },
      async onRowSelectedSetTest(item) {
        if (item.length <= 0) {
          return
        }
        this.$refs['detailAddModal'].close()
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการเลือก',
          text: `คุณต้องการเลือก ${item[0].name} ลดราคาใช่หรือไม่?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'เลือก',
          cancelButtonText: 'ยกเลิก',
          showLoaderOnConfirm: true,
        })

        if (confirm.value) {
          this.chooseItemHandler(item[0].id, item[0].name, 'setTest')
        } else {
          this.$refs['testTable'].clearSelected()
          this.$refs['setTestTable'].clearSelected()
          this.$refs['detailAddModal'].open()
        }
      },
      updateTestItems(text) {
        this.testSuggestList = this.tests.filter(testSuggestion => String(testSuggestion.name.toLowerCase()).includes(text.toLowerCase()))
      },
      updateSetTestItems(text) {
        this.setTestSuggestList = this.setTests.filter(testSuggestion => String(testSuggestion.name.toLowerCase()).includes(text.toLowerCase()))
      }
    },
  }
</script>

<style scoped>

</style>